import { BlockType } from '@next-space/fe-api-idl';
import { useEffect } from 'react';
import { uiActions } from 'src/redux/reducers/ui';
import { cache, dispatch } from 'src/redux/store';
import { $appUiStateCache } from 'src/services/app';
import { querySelectorFromMainContent } from 'src/utils/dom';
import { useGetPageId } from 'src/utils/getPageId';

export const useHandleClick = () => {
  const pageId = useGetPageId();

  useEffect(() => {
    const click = (event: MouseEvent) => {
      if (
        event.shiftKey &&
        event.target instanceof Element &&
        event.target.closest('[data-page-id]')
      ) {
        // 如果点击到页面内容上就需要屏蔽掉shift+click,handleMouseDown会处理这个case
        event.stopImmediatePropagation();
        event.preventDefault();
      }

      if (cache.ui.selectedBlocks.length) return;

      if (event.target instanceof Element) {
        const blockContent = event.target.closest('.block-content');
        const blockContentContainer = event.target.closest('.next-space-page ');

        // 点击到block外面,page内的时候
        if (blockContentContainer && !blockContent) {
          // 需要看看是不是同步块，是同步块就要选中这个块
          const pageBlock = cache.blocks[pageId];
          if (!pageBlock) return;

          const syncBlockIds = pageBlock.subNodes.filter((id) => {
            const block = cache.blocks[id];
            return (
              block?.type === BlockType.SYNC_CONTAINER || block?.type === BlockType.SYNC_REFERENCE
            );
          });

          const isInRightPanel = $appUiStateCache.$isFocusInRightPanel;
          for (const id of syncBlockIds) {
            const syncBlockNode = querySelectorFromMainContent(
              `[data-block-id="${id}"]`,
              isInRightPanel
            );

            if (!syncBlockNode) continue;

            const { top, bottom } = syncBlockNode.getBoundingClientRect();
            if (event.clientY > top && event.clientY < bottom) {
              dispatch(
                uiActions.update({
                  selectedBlocks: [{ blockId: id }],
                })
              );
              break;
            }
          }
        }
      }
    };

    document.addEventListener('click', click, true);

    return () => {
      document.removeEventListener('click', click, true);
    };
  }, [pageId]);
};
